export default function slideOnayami() {
  const mobileMatchMedia = window.matchMedia('(max-width: 1024px)');
  const setupSlider = () => {
    document.querySelectorAll('.js-onayamiSlider').forEach((element) => {
      if ('swiper' in element) {
        element.swiper.destroy();
        // eslint-disable-next-line no-param-reassign
        delete element.swiper;
        element.querySelectorAll('.swiper-button-lock').forEach((swiperButtonLock) => {
          swiperButtonLock.classList.remove('swiper-button-lock');
        });
      }

      const swiperSlideElements = element.querySelectorAll('.swiper-slide');

      if (
        !mobileMatchMedia.matches ||
        (mobileMatchMedia.matches && swiperSlideElements.length < 2)
      ) {
        return;
      }

      // eslint-disable-next-line no-new
      new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 35,
      });
    });
  };
  mobileMatchMedia.addListener(() => {
    setupSlider();
  });
  setupSlider();
}
